import React from "react";
import { ReactComponent as GuideIcon } from "assets/icons/guide-icon.svg";
import styles from "./GuideButton.module.scss";
import Tooltip from "../../components/Tooltip";
import { useTranslation } from "react-i18next";

type Props = {
  onClick?: () => void;
  className?: string;
};

export const GuideButton: React.FC<Props> = ({ onClick, className }) => {
  const { t } = useTranslation();
  return (
    <Tooltip text={t("openUserQuide")} position="top">
      <button
        className={`guide-button ${styles["button"]} ${className ?? ""}`}
        onClick={onClick}
      >
        <GuideIcon />
      </button>
    </Tooltip>
  );
};
